import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-three-q',
  templateUrl: './three-q.component.html',
  styleUrls: ['./three-q.component.scss']
})
export class ThreeQComponent implements OnInit {
  @Input() outputId;
  url: string;

  constructor() {
    /* const script = document.createElement('script');
    script.setAttribute('data-dataid', this.outputId);
    script.type = 'text/javascript';
    script.src = '//player.3qsdn.com/js3q.embed.min.js';
    document.body.appendChild(script); */
    /* const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://playout.3qsdn.com/player/js/sdnplayer.js';
    const s2 = document.createElement('script');
    s2.type = 'text/javascript';
    s2.src =
      'https://playout.3qsdn.com/ad7ce5d4-ebba-11eb-b839-0cc47a188158?js=true&container=sdnPlayer_mNRbWvgcnBQLpJh&width=640&height=360';
    document.body.appendChild(s);
    document.body.appendChild(s2); */
  }
  ngOnInit(): void {
    this.url = `https://playout.3qsdn.com/${this.outputId}`;
  }
}
